import { Component, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { FormValidationService } from 'services/form-validation.service';
import { TranslatePipe } from 'pipes/translate.pipe';
import { QuestionnaireComponent } from 'components/questionnaire/questionnaire.component';
import { Layout } from 'modules/layout';

@Component({
	selector: 'approve-order-component',
	templateUrl: './approve-order.component.html',
	providers: [FormValidationService],
	imports: [Layout, TranslatePipe, QuestionnaireComponent]
})
export class ApproveOrderComponent {

	@Input() orderId?: string;
	@Input() questionnaireId?: string;
	@Input() orderLines?: OrderLineModel[];
	@Output() approvedOrder = new EventEmitter<boolean>();
	@ViewChild(QuestionnaireComponent) questionnaire?: QuestionnaireComponent;

	async approveOrder() {
		if (!this.questionnaire) return;
		await this.questionnaire.saveAllReplies();
		
		this.approvedOrder.emit(true);
	}
}
